import { render, staticRenderFns } from "./GlyanecCalendars.vue?vue&type=template&id=13d5a334&scoped=true&"
import script from "./GlyanecCalendars.vue?vue&type=script&lang=js&"
export * from "./GlyanecCalendars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5a334",
  null
  
)

export default component.exports